import React, {useEffect, useState} from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import classnames from 'classnames'

// styles
import useStyles from './styles'

// components
import Header from '../Header'
import Sidebar from '../Sidebar'

// pages
import ListCustomers from "../../pages/customers/list";
import EditCustomer from "../../pages/customers/edit";
import AddCustomer from "../../pages/customers/add";
import DeviceListPage from "../../pages/devices/list";
import EditDevice from "../../pages/devices/edit";
import Occupancy from "../../pages/occupancy";
import Reports from "../../pages/reports";

// context
import { useLayoutState } from '../../context/LayoutContext'

//Sidebar structure
import structure from '../Sidebar/SidebarStructure'
import Rest from "../../helpers/Rest";
import {CircularProgress} from "@material-ui/core";
import Monitoring from "../../pages/devices/Monitoring";

function Layout(props) {
    const classes = useStyles()
    const [ready, setReady] = useState(false)

    useEffect(() => {
            if (!Rest.isAdmin){
                document.location = '/dashboard'
            }
            else{
                setReady(true)
            }
    })

    const layoutState = useLayoutState()

    if (!ready){
        return <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CircularProgress/>
        </div>
    }
    // global


    return (
        <div className={classes.root}>
            <Header history={props.history} />
            <Sidebar structure={structure} />
            <div
                className={classnames(classes.content, {
                    [classes.contentShift]: layoutState.isSidebarOpened,
                })}
            >
                <div className={classes.fakeToolbar} />
                <Switch>
                    <Route path="/app/list-customers" component={ListCustomers} />
                    <Route path="/app/edit-customer" component={EditCustomer} />
                    <Route path="/app/add-customer" component={AddCustomer} />
                    <Route path="/app/list-devices" component={DeviceListPage} exact/>
                    <Route path="/app/list-devices/:vehicleId" component={DeviceListPage} />
                    <Route path="/app/edit-device" component={EditDevice} />
                    <Route path="/app/occupancy" component={Occupancy} />
                    <Route path="/app/reports" component={Reports} />
                    <Route path="/app/monitoring/:filter" component={Monitoring} />
                </Switch>
            </div>
        </div>
    )
}

export default withRouter(Layout)
